import { observer } from 'mobx-react';

import { OptionType } from '@components/Select';
import { SelectListOption } from '@components/SelectList/SelectListOption';

interface Props {
    selectedId?: string;
    organization: OptionType<string>;
    onSelect(organizationId?: string): void;
}

export const OrganizationSelectItem = observer(({ organization, selectedId, onSelect }: Props) => (
    <div>
        <SelectListOption
            isSelected={organization.value === selectedId}
            id={organization.value}
            name={organization.label}
            onSelect={onSelect}
        />
    </div>
));
